import { render, staticRenderFns } from "./CancelIcon.vue?vue&type=template&id=5fc6c67f"
import script from "./CancelIcon.vue?vue&type=script&lang=js"
export * from "./CancelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports